var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgS5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 60,
    viewBox: "0 0 54 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8713_1779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8643 10.6187L34.7553 19.8266V38.1682L18.8643 28.9602V10.6187Z",
    fill: "#7D54B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5771 19.8266L53.4682 10.6187V28.9602L37.5771 38.1682V19.8266Z",
    fill: "#7D54B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.00292969 0L15.894 9.20792V27.5495L0.00292969 18.3416V0Z",
    fill: "#7D54B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8643 32.4507L34.7553 41.5843V60.0002L18.8643 50.7923V32.4507Z",
    fill: "#7D54B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8713_1779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53.472,
    height: 60,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS5);
export default __webpack_public_path__ + "static/media/s5.0aa5bcd1729ef252b4a9e69c3a14dea4.svg";
export { ForwardRef as ReactComponent };